/**
 * Content Highlights entitlements — keep subscription ids aligned with
 * `gaia-brooklyn-api/lib/services/transcript-chunk-search/entitlements.js`.
 */
import {
  ROLE_ID_EDITOR,
  ROLE_ID_EDITOR_PLUS,
  ROLE_ID_SITE_ADMIN,
  ROLE_ID_CUSTOMER_SERVICE,
  ROLE_ID_CUSTOMER_SERVICE_MANAGER,
  ROLE_ID_QA,
} from '../auth-access'

/** Subscription content_set_id values for member transcript chunk search. */
export const CONTENT_HIGHLIGHTS_SUBSCRIPTION_IDS = Object.freeze([253, 280, 290])

/** Elevated roles that bypass subscription gating (staff preview). */
export const CONTENT_HIGHLIGHTS_ELEVATED_ROLE_IDS = Object.freeze([
  ROLE_ID_EDITOR,
  ROLE_ID_EDITOR_PLUS,
  ROLE_ID_SITE_ADMIN,
  ROLE_ID_CUSTOMER_SERVICE,
  ROLE_ID_CUSTOMER_SERVICE_MANAGER,
  ROLE_ID_QA,
])
